import React from "react";

const Star = (props) => {
  const changeGrade = (e) => {
    let ratingScope = +e.target.id || +e.target.parentNode.id;
    if (ratingScope == 0) {
      ratingScope++;
    } else {
      ratingScope++;
    }
    props.changeGradeIndex(ratingScope);
  };
  return (
    <label className="star">
      <svg
        onClick={changeGrade}
        id={props.index}
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={props.style}
        stroke="#393939"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
      </svg>
    </label>
  );
};

export default Star;
